import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import DiagnosticForm from './pages/DiagnosticForm';
import Results from './pages/Results';
import Checkout from './pages/Checkout';
import PaymentSuccess from './pages/PaymentSuccess';
import { DPSOverview } from './pages/dps/DPSOverview';
import { DPSAnalysis } from './pages/dps/DPSAnalysis';
import { DPSActions } from './pages/dps/DPSActions';
import { DPSHistory } from './pages/dps/DPSHistory';
import LegalNotice from './pages/LegalNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ResetPassword from './pages/ResetPassword';
import UpdatePassword from './pages/UpdatePassword';
import Dashboard from './pages/Dashboard';
import AccountSettings from './pages/account/AccountSettings';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/auth/PrivateRoute';

function App() {
  const basename = import.meta.env.BASE_URL;

  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router basename={basename}>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/diagnostic" element={<DiagnosticForm />} />
              <Route path="/results" element={<Results />} />
              <Route path="/checkout" element={<PrivateRoute><Checkout /></PrivateRoute>} />
              <Route path="/payment/success" element={<PrivateRoute><PaymentSuccess /></PrivateRoute>} />
              <Route path="/dps/report/:id" element={<PrivateRoute><DPSOverview /></PrivateRoute>} />
              <Route path="/dps/report/:id/analysis" element={<PrivateRoute><DPSAnalysis /></PrivateRoute>} />
              <Route path="/dps/report/:id/actions" element={<PrivateRoute><DPSActions /></PrivateRoute>} />
              <Route path="/dps/report/:id/history" element={<PrivateRoute><DPSHistory /></PrivateRoute>} />
              <Route path="/mentions-legales" element={<LegalNotice />} />
              <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/update-password" element={<UpdatePassword />} />
              <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/account/settings" element={<PrivateRoute><AccountSettings /></PrivateRoute>} />
            </Routes>
          </Layout>
          <Toaster position="top-right" />
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;